/*
 * @Author: liyang
 * @Date: 2021-03-19 16:27:28
 * @LastEditTime: 2024-01-15 11:25:28
 * @LastEditors: Please set LastEditors
 * @FilePath: \ibu-owt-core-frontend\plugins\i18n.js
 * @Description:
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLocalesMessage } from '@/utils/locales/asyncLocal'

if (!Vue.useI18n) {
  Vue.useI18n = true
  Vue.use(VueI18n)
}

export default async ({ app, store }) => {
  const commonLocales = {}
  // 客户端-同步加载语言包
  if (process.client && store.state.locale) {
    const currentLocaleMessage = await getLocalesMessage(store.state.locale)
    commonLocales[store.state.locale] = currentLocaleMessage;
  }  
  app.i18n = new VueI18n({
    locale: store.state.locale,
    fallbackLocale: 'zh-CN', // 默认语言为中文
    missing: (locale, key, vm) => {
      // 在线申报missing特殊处理,解决关务没有国际化配置的问题
      if (key.includes('serviceSupport.clearanceService.apply.')) {
        const lastIndex = key.lastIndexOf('.') + 1
        return key.substring(lastIndex)
      }
      return key
    },
    // // 是否取消本地化失败时输出的警告。如果为 true，则禁止本地化失败警告。
    // silentTranslationWarn: true,
    // // 是否在回退到 fallbackLocale 或 root 时取消警告。如果为 true，则仅在根本没有可用的转换时生成警告，而不是在回退时。
    // silentFallbackWarn: true,
    messages: {
      'zh-CN': require('@/locales/zh-CN.json'),
      ...commonLocales,
    },
  })
}
